export const LayoutAvatar = (props: any) => {
  return (
    <svg
      className="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      {...props}
    >
      <path d="M426.6496 597.3504A341.3504 341.3504 0 0 1 768 938.6496H85.3504a341.3504 341.3504 0 0 1 341.2992-341.2992z m314.1632 52.5824a320.2048 320.2048 0 0 1 239.8208 288.768h-127.2832a425.2672 425.2672 0 0 0-112.5376-288.768zM426.6496 42.7008c141.4656 0 256 114.5344 256 256 0 141.4144-114.5344 256-256 256-141.4144 0-256-114.5856-256-256 0-141.4656 114.5856-256 256-256z m298.0352 89.4464a213.3504 213.3504 0 0 1-70.144 420.6592A340.48 340.48 0 0 0 768 298.6496a339.8144 339.8144 0 0 0-43.3152-166.5024z"></path>
    </svg>
  )
}
